import React from 'react';
import { View } from 'react-native-web';
import BreakLine from './BreakLine';
import Title from '../Text/Title';
import { Asset_requirements } from '../../../utils/DictionaryManagementUtils';
import Paragraph from '../Text/Paragraph';
import Details from '../Text/Details';

//= ========================================================================

const AssetRequirements = ({
  paragraph,
  details,
}) => (
  <View>
    <BreakLine />
    <Title isBold>{Asset_requirements}</Title>
    <Paragraph>{paragraph}</Paragraph>
    <Details>{details}</Details>
  </View>
);

export default AssetRequirements;
